/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-unknown-property */
/* eslint-disable no-useless-escape */
/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../Components/Header";
import SubHeader from "../Components/SubHeader";
import Loader from "../Components/Loader";
import Footer from "../Components/Footer";
import Cookies from "js-cookie";

import "../Styles/ofislerimiz.css";
import PDFViewer from "../Components/PDFViewer";

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let navigate = useNavigate();
    let params = useParams();
    return <Component {...props} router={{ navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

class PrivacyPolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      isCollapsed: false,
      isMenuOpen: false,
      activeTab: "tab-1",
      isMobile: window.innerWidth <= 1400,
      belge: null, // panelden yayınlanan Gizlilik sürümü (metni varsa sabit aydınlatma metninin yerine gösterilir)
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false });
    }, 500);
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleResize);
    this.handleScroll();
    this.yayindakiSurumuGetir();
  }

  // Yayındaki sürümün metni ut-admin'den girildiyse sayfadaki sabit metin yerine o gösterilir
  yayindakiSurumuGetir = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/belgeler/yayinda/gizlilik`);
      const result = await response.json();
      if (result.m === "basarili") this.setState({ belge: result.belge });
    } catch (error) {
      console.error("Gizlilik politikası sürümü alınamadı:", error);
    }
  };

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth <= 768 });
  };

  handleScroll = () => {
    const scrollTop = window.pageYOffset;
    const isCollapsed = scrollTop > 60;
    this.setState({ isCollapsed });
  };

  render() {
    // Üyelik sözleşmesi PDF değil: panelden yayınlanan güncel sürüm web sayfasında (eski PDF 2.0'da kalmıştı)
    const documents = [
      {
        title: "UNIVERSAL TEAM KVKK POLİTİKASI",
        path: "/Assets/PDF/kvkk.pdf",
      },
      {
        title: "ÇEREZ POLİTİKASI",
        path: "/Assets/PDF/cerezPolitikasi.pdf",
      },
      {
        title: "KİŞİSEL VERİ SAKLAMA VE İMHA POLİTİKASI",
        path: "/Assets/PDF/veriSaklama.pdf",
      },
      {
        title: "VERİ SAHİBİ BAŞVURU FORMU",
        path: "/Assets/PDF/veriSahibi.pdf",
      },
    ];

    const { isMobile } = this.state;

    return (
      <>
        <Loader />
        <SubHeader />
        <Header isLoggedIn={Cookies.get("token") == null ? false : true} />

        <div className="offices-header">
          <div className="offices-header-pattern" />

          <div className="container offices-header-container">
            <div className="row">
              <div className="text-center">
                <h1 className="offices-header-title">
                  NM Universal Team
                  <br />
                  Mobil Uygulaması Web Sitesi Politikaları
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div className="ex-basic-2">
          <div className="container">
            <div className="row mt-5 mb-5">
              <div className="col-lg-12">
                <div className="metin-kutusu">
                  {this.state.belge && this.state.belge.metin && (
                    <div>
                      <h1>{this.state.belge.baslik}</h1>
                      <p>
                        <strong>
                          Sürüm {this.state.belge.surum} · Yürürlük: {this.state.belge.yururlukMetin}
                        </strong>
                      </p>
                      <div style={{ whiteSpace: "pre-wrap" }}>{this.state.belge.metin}</div>
                    </div>
                  )}
                  <div style={{ display: this.state.belge && this.state.belge.metin ? "none" : undefined }}>
                  <h1>
                    KİŞİSEL VERİLERİN KORUNMASINA İLİŞKİN AYDINLATMA METNİ
                  </h1>

                  <p>
                    <strong>1 -</strong>Adil Onur Karahan Şahıs
                    Şirketi (<strong>"Şirket"</strong> olarak anılacaktır)
                    olarak; kişisel verilerinizin gizliliği ve güvenliği en
                    önemli önceliklerimiz arasındadır. Şirketimiz, 6698 sayılı
                    Kişisel Verilerin Korunması Kanunu ("KVKK") düzenlemelerine
                    ve ikincil mevzuata uyumlu bir şekilde kişisel verilerinizi
                    işlemektedir. Kişisel verileriniz, kimliğinizi belirli ya da
                    belirlenebilir kılan her türlü bilgi anlamına gelmektedir.
                    <br />
                    <br />
                    Şirketimize ait mobil uygulamalarda (
                    <strong>"Platform"</strong> olarak anılacaktır) sunulan
                    hizmetlerden (<strong>"Platform Hizmetleri"</strong> olarak
                    anılacaktır) yararlanabilmek amacıyla Üyelik Sözleşmesi'ni
                    kabul ederek <strong>"Platform Üyesi"</strong> olmanız
                    halinde işlenen kişisel verileriniz hakkında sizleri
                    bilgilendirmek isteriz.
                    <br />
                    <br />
                    <strong>2 - Hangi kişisel verilerinizi işliyoruz?</strong>
                    <br />
                    Platform Üyesi olmanız halinde, aşağıdaki kişisel
                    verileriniz işlenmektedir.
                    <br />
                    <br />• <strong>Kullanıcı Hesap Bilgileriniz:</strong>{" "}
                    adınız, soyadınız, müşteri numaranız, üyelik e-posta
                    adresiniz ve kullanıcı bilgilerinize eklemeniz halinde
                    telefon numaranız, cinsiyet, doğum tarihi, boy ve kilo
                    bilginiz, T.C. Kimlik Numaranız,
                    <br />
                    <br />• <strong>
                      Üyelik Bilgilerinizin Kapsamında:
                    </strong>{" "}
                    Talep ve şikayet bilgileriniz, Platform kullanım
                    bilgileriniz, Platform'da yer alan gruplamalara ilişkin
                    sıralama, puan bilgileri, Platform'da yer alan günlük akış
                    kısmında tarafınızca paylaşılan görsel ve işitsel
                    bilgileriz, Platform'da yer alan paylaşımlara ilişkin yorum
                    yapmanız ve/veya soru sormanız halinde yorum ve sorularınız
                    içerisinde bizzat paylaştığınız bilgiler, puan ve
                    değerlendirme bilgileriniz, chat kanalıyla yapılan konuşma
                    içeriklerine yönelik bilgiler,
                    <br />
                    <br />• <strong>Platform Kullanım Kapsamında:</strong>{" "}
                    Rızaya dayalı araç paylaşımlı seyahat durumunda güzergah,
                    araç bilgisi, kişi sayısı bilgileriniz, eğitim ilanları
                    kapsamında eğitici konumunda paylaştığınız kimlik bilgileri
                    ile fotoğraf, video gibi görsel bilgiler,
                    <br />
                    <br />• <strong>Ödeme Bilgileriniz:</strong> tarafınızca
                    yapılan ödemelere ve ödeme yöntemlerine ilişkin
                    bilgileriniz, kayıtlı kart bilgileriniz,
                    <br />
                    <br />• <strong>İşlem Güvenliği Bilgileriniz:</strong> cihaz
                    bilgileriniz, IP adresi bilgisi, şifre ve parola
                    bilgileriniz, çerez bilgileriniz, platform erişim kayıtları,
                    giriş yapma yönteminiz (Google/Facebook aracılığıyla),
                    <br />
                    <br />• <strong>Hukuki İşlem Bilgileriniz:</strong> yetkili
                    kişi, kurum ve kuruluşlarla yazışmalardaki bilgiler, dava ve
                    icra dosyalarındaki bilgiler, yasal bilgi talebi
                    bilgileriniz,
                    <br />
                    <br />•{" "}
                    <strong>
                      Ek hizmetler kapsamında işlenen kişisel verileriniz:
                    </strong>{" "}
                    Platform'da sunulan takvim ve görevler ek hizmetlerden
                    faydalanmanız halinde paylaşılan etkinlik bilgileri
                    kapsamında belirtilen eğitim, hedef bilgileri ile ilişkili
                    üyelik, kimlik verileriniz.
                    <br />
                    <br />
                    <strong>
                      3 - Kişisel verilerinizin işlenmesinin hukuki sebepleri,
                      amaçları ve toplama yöntemleri nelerdir?
                    </strong>
                    <br />
                    Kişisel verileriniz, Şirketimiz tarafından tamamen veya
                    kısmen otomatik olan ya da herhangi bir veri kayıt
                    sisteminin parçası olmak kaydıyla otomatik olmayan yollarla,
                    üyelik sözleşmemiz kapsamında Şirketimize ait
                    yararlandığınız Platform Hizmeti'nin yer aldığı mobil
                    uygulama üzerinden elektronik ortamda; e-posta kanallarıyla
                    iletişime geçtiğinizde ise iletişime geçtiğiniz kanal
                    vasıtasıyla elektronik ortamda ve Şirketimize matbu formlar,
                    tebligat, posta yoluyla iletilmesi veya yasal merciler
                    tarafından tebliğ edilmesi halinde fiziki ortamda
                    toplanmaktadır. İşlenen kişisel verileriniz, işlenme
                    amaçları ve hukuki sebeplerine aşağıda yer verilmiştir.
                    <br />
                    <br />
                    <strong>
                      3.1 Üyelik ve Hesap Oluşturma Platform Kullanım Kapsamı
                      Sürecinde:
                    </strong>
                    <br />
                    <br />
                    <strong>
                      Bu kategoride işlenen kişisel verileriniz:
                    </strong>{" "}
                    Kullanıcı hesap bilgileriniz, üyelik bilgileriniz, işlem
                    güvenliği bilgileriniz.
                    <br />
                    <br />
                    <strong>Amaçlar:</strong>
                    <br />
                    <br />
                    • Üyelik sözleşmesinin kurulması ve ifasına yönelik
                    süreçlerin yürütülmesi,
                    <br />
                    <br />
                    • Platform üye profilinin/hesabın oluşturulması ve
                    kapatılması süreçlerinin yönetilmesi, • İletişim
                    bilgilerinin doğrulanması,
                    <br />
                    <br />
                    • Platform vasıtasıyla puan, sıralama işlemlerinizin
                    gerçekleştirilmesine yönelik faaliyetlerin yürütülmesi,
                    <br />
                    <br />
                    • Şirket'in eğitim ve iş faaliyetlerinin yürütülmesi ve
                    denetimi,
                    <br />
                    <br />
                    • Platform operasyonlarının güvenliğinin sağlanması,
                    <br />
                    <br />
                    • 6563 Elektronik Ticaretin Düzenlenmesi Hakkında Kanun,
                    6102 Sayılı Türk Ticaret Kanunu, 5237 Sayılı Türk Ceza
                    Kanunu ve 6502 sayılı Tüketicinin Korunması Hakkında Kanun
                    başta olmak üzere Şirketimizin tabi olduğu mevzuattan
                    kaynaklanan yükümlülüklerin yerine getirilmesi,
                    <br />
                    <br />
                    • Platform faaliyetlerinin mevzuata uygun olarak
                    yürütülmesi,
                    <br />
                    <br />
                    • Mevzuattan kaynaklanan yükümlülüklerimiz uyarınca
                    Şirketimiz tarafından veri paylaşımı ve muhafazası
                    yükümlülüklerinin yerine getirilmesi.
                    <br />
                    <br />
                    <strong>Hukuki Sebepler:</strong> Kanunlarda açıkça
                    öngörülmüş olması, Şirketimizin hukuki yükümlülüklerinin
                    yerine getirilmesi için zorunlu olması, Sizinle aramızdaki
                    üyelik sözleşmemizin ifası için gerekli olması. Platform
                    Hizmetleri'nden Misafir üye olarak yararlanmanız halinde
                    işlenen kişisel verileriniz için detaylı bilgiye "Üye
                    olmadan devam et" butonuna tıkladığınızda çıkan ekranda yer
                    alan aydınlatma metninden ulaşabilirsiniz.
                    <br />
                    <br />
                    <strong>
                      3.2 Üyelik Deneyiminin ve Platform Süreçlerinin
                      İyileştirilmesi Süreçleri:
                    </strong>
                    <br />
                    Bu kategoride işlenen kişisel verileriniz: Kullanıcı hesap
                    bilgileriniz, platform kullanım kapsamındaki bilgileriniz,
                    işlem güvenliği bilgileriniz, hukuki işlem bilgileriniz.
                    <br />
                    <br />
                    <strong>Amaçlar:</strong>
                    <br />
                    <br />
                    • Şirketimize ait Platform Hizmetleri kapsamında daha iyi
                    bir kullanıcı deneyiminin sağlanması,
                    <br />
                    <br />
                    • Kullanıcı deneyimizin geliştirilmesi ve iyileştirilmesi,
                    <br />
                    <br />
                    • Hizmetkalitemizin iyileştirilmesi,
                    <br />
                    <br />
                    • Analiz ve raporlama çalışmalarının yapılması,
                    <br />
                    <br />
                    • Puanlama, değerlendirme ve sıralama çalışlamalarının
                    yapılması,
                    <br />
                    <br />
                    • İletişim faaliyetlerinin yürütülmesi,
                    <br />
                    <br />
                    • Talep, şikayet ve önerilerin değerlendirilmesi, Hukuki
                    Sebepler: Sizinle aramızdaki üyelik sözleşmemizin ifası için
                    gerekli olması, Şirketimizin meşru menfaatleri için veri
                    işlenmesinin zorunlu olması.
                    <br />
                    <br />
                    <strong>
                      3.3 Şirketin Bilgi Güvenliği, Risk, Denetim ve Kontrol
                      Süreçleri:{" "}
                    </strong>
                    Bu kategoride işlenen kişisel verileriniz: Kullanıcı hesap
                    bilgileriniz, üyelik işlem bilgileriniz, ödeme bilgileriniz,
                    işlem güvenliği bilgileriniz.
                    <br />
                    <br />
                    Amaçlar:
                    <br />
                    <br />
                    • Finans ve muhasebe süreçlerinin yürütülmesi ve denetimi,
                    <br />
                    <br />
                    • Faturalandırma süreçlerinin yürütülmesi,
                    <br />
                    <br />
                    • Bilgi güvenliği süreçlerinin yürütülmesi ve şüpheli
                    işlemlere yönelik inceleme yapılması,
                    <br />
                    <br />
                    • Platform'a ilişkin olarak operasyonların güvenliğinin
                    sağlanması,
                    <br />
                    <br />• Risk tespiti ve analizlerinin yapılması, şikâyet
                    yönetimi yapılması,
                    <br />
                    <br />• Dolandırıcılıkların önlenmesi,
                    <br />
                    <br />
                    • Olası şirket birleşme, devralma, ortak girişim, bölünme ve
                    sair yapısal değişikliklerde Şirketimizin hukuki ve finansal
                    inceleme faaliyetlerinin gerçekleştirilmesi.
                    <br />
                    <br />
                    <strong>Hukuki Sebepler:</strong> Sizinle aramızdaki üyelik
                    sözleşmemizin ifası için gerekli olması, Şirketimizin meşru
                    menfaatleri için veri işlenmesinin zorunlu olması. 3.4
                    Hukuki İşlemlerin Yürütülmesi Süreci: Bu kategoride işlenen
                    kişisel verileriniz: Kullanıcı hesap bilgileriniz, üyelik
                    işlem bilgileriniz, ödeme bilgileriniz, işlem güvenliği
                    bilgileriniz, hukuki işlem bilgileriniz.
                    <br />
                    Amaçlar: • Hukuk ve dava işlerinin yürütülmesi, hukuki
                    taleplerinizin cevaplandırılması, ilgili kişi olarak usulüne
                    uygun olan başvurularınızın incelenmesi ve yanıtlanması, •
                    Faaliyetlerin mevzuata uygun yürütülmesi, Şirketimizin tabi
                    olduğu mevzuattan kaynaklanan yükümlülüklerin yerine
                    getirilmesi, • Hukuki danışmanlık süreçlerinin yürütülmesi,
                    • Talep edilmesi halinde yetkili kişi, kurum ve kuruluşlarla
                    bilgi paylaşılması, • Hukuki bir ihtilaf olması halinde bir
                    hakkın kullanılması ve korunması. Hukuki Sebepler: Bir
                    hakkın tesisi, kullanılması veya korunması için veri
                    işlemenin zorunlu olması, Şirketimizin hukuki
                    yükümlülüklerinin yerine getirilmesi için zorunlu olması.
                    <br />
                    <br />
                    <strong>
                      3.5 Açık Rızaya Dayalı Yürütülen Süreçler:
                    </strong>{" "}
                    Bu kategoride işlenen kişisel verileriniz: Kullanıcı hesap
                    bilgileriniz, üyelik işlem bilgileriniz, ödeme bilgileriniz.
                    Amaçlar: • Pazarlama, reklam ve tanıtım faaliyetlerinin
                    yürütülmesi, • Finansal teklif süreçlerinin yürütülmesi, •
                    Sizin rızanız kapsamında kullanılacak olan araç paylaşımlı
                    taşımalı faaliyete yönelik paylaşımlar, günlük akış
                    kapsamında paylaşılan görsel içerikli paylaşımlar, sizleri
                    daha iyi tanıyarak memnuniyetinizin arttırılmasına yönelik
                    faaliyetlerin yürütülmesi ve bu kapsamda çalışmaların
                    yapılması. Hukuki Sebep: Açık rızanızın bulunması. Önemle
                    belirtmek isteriz ki, verdiğiniz onayı geri almak istemeniz
                    halinde "7-Hak ve Talepleriniz İçin İletişim" başlığı
                    altında yer alan yöntemlerle Şirket'e bu husustaki
                    talebinizi iletebilirsiniz.
                    <br />
                    <br />
                    <strong>
                      4 - Şirket kişisel verilerinizi kimlere hangi sebeplerle
                      aktarıyor?{" "}
                    </strong>
                    Şirketimiz, kişisel verilerinizi "bilme gereği" ve "kullanma
                    gereği" ilkelerine uygun olarak, gerekli veri
                    minimizasyonunu sağlayarak ve gerekli teknik ve idari
                    güvenlik tedbirlerini alarak işlemeye özen göstermektedir.
                    Şirketimiz tarafından, kişisel verileriniz yurt içinde
                    KVKK'nın 8. maddesi uyarınca "Kanunlarda açıkça öngörülmesi,
                    Şirketimizin hukuki yükümlülüklerinin yerine getirebilmesi
                    için zorunlu olması, sözleşmenin kurulması veya ifası için
                    gerekli olması, bir hakkın tesisi, kullanılması veya
                    korunması için veri işlemenin zorunlu olması ve/veya
                    Şirketimizin meşru menfaati için zorunlu olması" hukuki
                    sebeplerine dayanılarak hizmet sağlayacılarımızla, alıcı
                    grupları, bilişim altyapısı, yazılım ve teknoloji hizmetleri
                    sunan iştiraklerimizle ile paylaşılmaktadır. Aynı zamanda
                    Şirketimizin tabi olduğu mevzuattan kaynaklanan
                    yükümlülüklerin yerine getirilmesi ve Platform
                    faaliyetlerinin mevzuata uygun olarak yürütülmesi, yetkili
                    kişi, kurum ve kuruluşlara bilgi verilmesi, hukuk işlerinin
                    takibi ve yürütülmesi, hukuki bir ihtilaf olması halinde bir
                    hakkın kullanılması ve korunması amaçlarıyla düzenleyici ve
                    denetleyici kurumlar ile mahkeme ve icra müdürlükleri,
                    arabulucular gibi yetkili kamu kurum ve kuruluşlarıyla,
                    Şirketimizin denetim faaliyetlerinin yürütülmesi, hukuki
                    danışmanlık süreçlerinin yürütülmesi, şirket
                    operasyonlarının güvenliğinin sağlanması, şüpheli işlemlere
                    yönelik inceleme yapılması amaçlarıyla avukatlar,
                    denetçiler, vergi danışmanları, adli bilişim uzmanları,
                    siber güvenlik danışmanları, vergi danışmanları,
                    iştiraklerimiz, danışmanlık ve hizmet aldığımız diğer üçüncü
                    kişiler ve iş ortaklarıyla paylaşılmaktadır. Paylaşımların
                    hukuki sebepleri ise; Kanunlarda açıkça öngörülmüş olması,
                    Şirketimizin hukuki yükümlülüklerinin yerine getirilmesi,
                    Bir hakkın tesisi, kullanılması veya korunması için
                    işlenmesi, Sözleşmenin kurulması veya ifası için gerekli
                    olması hallerinden birinin varlığıdır. Bununla birlikte açık
                    rızanın bulunması hukuki sebebine dayanarak Pazarlama,
                    reklam ve tanıtım faaliyetlerinin yürütülmesi, sizleri daha
                    iyi tanıyarak memnuniyetinizin arttırılmasına yönelik
                    faaliyetlerin yürütülmesi amaçlarıyla iştirakler hizmet
                    sağlayıcı ve iş ortaklarıyla paylaşılmaktadır.
                    <br />
                    <br />
                    <strong>
                      5 - Şirket Kişisel Verilerinizi Nasıl Koruyor?{" "}
                    </strong>
                    Şirketimiz kapsamında Platformumuz ile paylaşılan kişisel
                    veriler, Şirket gözetimi ve kontrolü altındadır. Şirket,
                    yürürlükteki ilgili mevzuat hükümleri gereğince bilginin
                    gizliliğinin ve bütünlüğünün korunması amacıyla gerekli
                    organizasyonu kurmak ve teknik önlemleri almak ve uyarlamak
                    konusunda veri sorumlusu sıfatıyla sorumluluğu üstlenmiştir.
                    Bu konudaki yükümlülüğümüzün bilincinde olarak; • Veri
                    gizliliğini konu alan uluslararası ve ulusal teknik
                    standartlara uygun surette periyodik aralıklarda güvenlik
                    testleri yaptırılmaktadır. • Web sitesi, mobil site ve mobil
                    uygulama aracılığıyla Şirket'e ilettiğiniz kişisel
                    verileriniz SSL (Secure Sockets Layer) teknolojisi
                    kullanılarak korunmaktadır. • Kişisel veri işleme
                    faaliyetlerine ilişkin düzenli olarak risk analizleri
                    yapılmakta ve risklerin azaltılması için aksiyonlar
                    alınmaktadır. • Kişisel verilere yetkisiz erişimleri
                    engellemek için erişim ve yetki kontrolleri uygulanmaktadır.
                    • Veri işleme politikaları düzenli aralıklarla
                    güncellenmektedir.
                    <br />
                    <br />
                    <strong>
                      6 - Kişisel Verilerinizin Korunmasına Yönelik Haklarınız{" "}
                    </strong>
                    Bu aydınlatma metninin "Hak ve Talepleriniz İçin İletişim"
                    bölümünde yer alan yöntemlerle Şirketimize başvurarak, •
                    Kişisel verilerinizin işlenip işlenmediğini öğrenme, •
                    İşlenmişse buna ilişkin bilgi talep etme, • Kişisel
                    verilerinizin işlenme amacını ve bunların amacına uygun
                    kullanılıp kullanılmadığını öğrenme, • Yurt içinde veya yurt
                    dışında aktarıldığı üçüncü kişileri bilme, • Kişisel
                    verilerin eksik veya yanlış işlenmiş olması halinde bunların
                    düzeltilmesini isteme, • KVKK'da öngörülen şartlar
                    çerçevesinde kişisel verilerinizin silinmesini veya yok
                    edilmesini isteme, • Yukarıda belirtilen düzeltme, silinme
                    ve yok edilme şeklindeki haklarınız uyarınca yapılan
                    işlemlerin, kişisel verilerin aktarıldığı üçüncü kişilere
                    bildirilmesini isteme, • İşlenen kişisel verilerinizin
                    münhasıran otomatik sistemler ile analiz edilmesi sureti ile
                    aleyhinize bir sonucun ortaya çıkmasına itiraz etme, •
                    Kişisel verilerinizin ilgili mevzuata aykırı olarak
                    işlenmesi sebebiyle zarara uğramanız hâlinde zararınızın
                    giderilmesini talep etme haklarına sahipsiniz.
                    <br />
                    <br />
                    <strong>7 - Hak ve Talepleriniz İçin İletişim </strong>
                    Kişisel verilerinizle ilgili sorularınızı ve taleplerinizi,
                    Veri Sorumlusuna Başvuru Usul ve Esasları hakkında Tebliğ'de
                    belirtilen şartlara uygun düzenlenmiş dilekçeyle ya da "
                    Adil Onur Karahan Şahıs Şirketi Başvuru
                    Formu" ile aşağıdaki yöntemlerle iletebilirsiniz. Başvuru
                    formuna ulaşabilirsiniz.
                    <br />
                    <br />
                    <table
                      style={{
                        borderCollapse: "collapse",
                        width: "100%",
                        border: "1px solid #ddd",
                      }}
                    >
                      <thead>
                        <tr style={{ backgroundColor: "#f5f5f5" }}>
                          <th
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                              textAlign: "left",
                            }}
                          >
                            Başvuru Yöntemi
                          </th>
                          <th
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                              textAlign: "left",
                            }}
                          >
                            Başvurunun Yapılacağı Adres
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                            }}
                          >
                            Şahsen Yazılı Başvuru**
                          </td>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                            }}
                          >
                            KIZILIRMAK MAH. UFUK ÜNİVERSİTESİ CAD. NO: 12 İÇ
                            KAPI NO: 3 ÇANKAYA/ ANKARA
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                            }}
                          >
                            Noter
                          </td>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                            }}
                          >
                            KIZILIRMAK MAH. UFUK ÜNİVERSİTESİ CAD. NO: 12 İÇ
                            KAPI NO: 3 ÇANKAYA/ ANKARA
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                            }}
                          >
                            E-posta
                          </td>
                          <td
                            style={{
                              border: "1px solid #ddd",
                              padding: "10px",
                            }}
                          >
                            Platforma daha önce bildirilen ve sistemde kayıtlı
                            bulunan elektronik posta adresinizden
                            yazilimkodjet@gmail.com
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <br />
                    *Başvuru formunun tebligat zarfına veya e-postanın konu
                    kısmına "Kişisel Verilerin Korunması Kanunu İlgili Kişi
                    Talebi" yazılmasını rica ederiz.
                    <br />
                    <br />
                    **"Şahsen Yazılı Başvuru" yoluna başvuracak İlgili Kişilerin
                    kimliğini tespit edici belgeleri ibraz etmesi gerekmektedir.
                    Bu bağlamda yukarıda yazılı adrese yapacağınız şahsen yazılı
                    başvurularda başvuru formuyla birlikte kimlik fotokopisinin
                    yalnızca ön yüzünün (kan grubu ve din hanesi gözükmeyecek
                    şekilde) ibraz edilmesini rica ederiz.
                    <br />
                    <br />
                    Kişisel veri sahipleri olarak, haklarınıza ilişkin
                    taleplerinizi, Şirket'e iletmeniz durumunda Şirket
                    talebinizi en geç 30 (otuz) gün içinde ücretsiz olarak
                    sonuçlandıracaktır. Ancak, başvurunuza verilecek yanıtın
                    mevzuat uyarınca bir maliyet gerektirmesi halinde Şirket
                    tarafından Kişisel Verileri Koruma Kurulu tarafından
                    belirlenen tarifedeki ücret talep edilebilecektir.
                    <br />
                    <br />
                    <strong>8 - Aydınlatma Metni Hakkında </strong>
                    Şirket işbu Kişisel Verilerin Korunmasına İlişkin Aydınlatma
                    Metni'ni yürürlükteki mevzuatta yapılabilecek değişiklikler
                    çerçevesinde her zaman güncelleme hakkını saklı tutar.
                    <br />
                    <br />
                    Güncellenme Tarihi: 28.04.2026
                  </p>
                  </div>
                  <div className="mt-5">
                    <h3
                      className="mb-4"
                      style={{
                        color: "#333",
                        fontWeight: "bold",
                        borderBottom: "2px solid #667eea",
                        paddingBottom: "10px",
                      }}
                    >
                      📄 Diğer Politikalarımız
                    </h3>

                    <p style={{ marginBottom: "15px" }}>
                      <a
                        href="/gizlilik_politikasi/uyelik_satis_sozlesmesi"
                        style={{ color: "#667eea", fontWeight: "bold" }}
                      >
                        Üyelik ve Satış Sözleşmesi
                      </a>
                    </p>

                    {isMobile ? (
                      // Telefonda PDF görüntüleyici yerine düz bağlantılar: belge tarayıcının kendi PDF açıcısında açılır
                      <ul style={{ paddingLeft: "18px", margin: 0 }}>
                        {documents.map((doc) => (
                          <li key={doc.path} style={{ marginBottom: "10px" }}>
                            <a
                              href={doc.path}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: "#667eea", fontWeight: "bold" }}
                            >
                              {doc.title}
                            </a>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <div
                        className="documents-section"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                        }}
                      >
                        {documents.map((doc, index) => (
                          <PDFViewer
                            key={index}
                            title={doc.title}
                            filePath={doc.path}
                          />
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default withRouter(PrivacyPolicy);
